import { Box } from '@mui/material';
import { SxProps } from '@mui/material/styles';
import useTranslation from 'next-translate/useTranslation';
import { FC } from 'react';
import useUser from '@utils/context/user';
import isAllowedToConsumePaidContent from '@utils/user';

interface PremiumFunctionalityIndicatorProps {
    sx?: SxProps;
}

const PremiumFunctionalityIndicator: FC<PremiumFunctionalityIndicatorProps> = ({ sx }) => {
    const { t } = useTranslation('common');
    const { privileges } = useUser();

    const isPremiumUser = isAllowedToConsumePaidContent(privileges);

    return isPremiumUser ? null : (
        <Box
            alt={t('premiumFunctionality')}
            component="img"
            height={19}
            src="/assets/crown.svg"
            sx={sx || {}}
            title={t('premiumFunctionality')}
            width={19}
        />
    );
};
export default PremiumFunctionalityIndicator;
